<article class="freemium-premium-compare-access__freemium-card">

    <header class="freemium-premium-compare-access__freemium-header">
        <h2 class="freemium-premium-compare-access__freemium-title">{{'freemium.free' | translate}}</h2>
        <div class="freemium-premium-compare-access__freemium-price">
            <div>{{'freemium.free_price' | translate}}</div>
            <small>
                {{'freemium.no_fees' | translate}}
                <br />
                {{'freemium.no_ads' | translate}}
            </small>
        </div>
        <p class="freemium-premium-compare-access__freemium-subtitle">{{'freemium.currently_use_it' | translate}}</p>
    </header>

    <div class="freemium-premium-compare-access__freemium-content">
        <ul class="freemium-premium-compare-access__freemium-feature-list">
            <li class="freemium-premium-compare-access__freemium-feature-item">{{'freemium.selection_of_lessons_throughout_the_year' | translate}} </li>
            <li class="freemium-premium-compare-access__freemium-feature-item">{{'freemium.overview_of_the_complementary_tools' | translate}} </li>
        </ul>
    </div>

    <footer class="freemium-premium-compare-access__freemium-footer">
        <button (click)="action(false)" class="freemium-premium-compare-access__freemium-button" data-e2e="freemium-premium-compare-access-continue-free">
            <span>{{'freemium.continue_with_the_free_version' | translate}} </span>
        </button>
    </footer>

</article>

<article class="freemium-premium-compare-access__premium-card">

    <header class="freemium-premium-compare-access__premium-header">
        <h2 class="freemium-premium-compare-access__premium-title">{{'freemium.premium' | translate}} </h2>
        <div class="freemium-premium-compare-access__premium-price">
            <div>{{'freemium.premium_price' | translate}}</div>
            <small>
                {{'freemium.per-month' | translate}}
                <br />
                {{'freemium.with_annual_commitment' | translate}}
            </small>
        </div>
        <p class="freemium-premium-compare-access__premium-subtitle">{{'freemium.all_lessons_and_unlimited_access_to_additional_tools' | translate}}</p>
    </header>

    <div class="freemium-premium-compare-access__premium-content">
        <ul class="freemium-premium-compare-access__premium-feature-list">
            <li class="freemium-premium-compare-access__premium-feature-item">{{'freemium.all_lessons_from_cp_to_cm2' | translate}}</li>
            <li class="freemium-premium-compare-access__premium-feature-item">{{'freemium.flashcards_and_the_language_lab' | translate}}</li>
            <li class="freemium-premium-compare-access__premium-feature-item">{{'freemium.simplified_individual_access_dedicated_to_students' | translate}} </li>
            <li class="freemium-premium-compare-access__premium-feature-item">{{'freemium.the_course_editor' | translate}}</li>
            <li class="freemium-premium-compare-access__premium-feature-item">{{'freemium.tools-list' | translate}}</li>
            <li class="freemium-premium-compare-access__premium-feature-item">{{'freemium.assignment_and_tracking_tools' | translate}}</li>
        </ul>
    </div>

    <footer class="freemium-premium-compare-access__premium-footer">
        <button class="freemium-premium-compare-access__premium-button"
        data-e2e="freemium-premium-compare-access-upgrade-premium"
        (click)="action(true)">
            <span>{{'freemium.upgrade_to_premium' | translate}}</span>
            <mat-icon svgIcon="freemium-premium-compare-access__start-premium"></mat-icon>
        </button>
    </footer>

</article>
